
export default {
  props: {
    src: String
  },
}
